export default "/dist/files/mdr-plein-stroke.7eebe81a68e388304f27ca7556c186b7.svg";